import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityActividadesGrupoEspecieAdapter, EntityActividadesGrupoEspecieState } from './entity-actividades-grupo-especie.state';

const { selectEntities, selectAll } = entityActividadesGrupoEspecieAdapter.getSelectors();

export const getError = (state: EntityActividadesGrupoEspecieState): any => state.error;

export const getIsLoading = (state: EntityActividadesGrupoEspecieState): boolean =>
  state.isLoading;

export const selectActividadesGrupoEspecieState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.actividadesGrupoEspecie
);

export const selectAllActividadesGrupoEspecie = createSelector(selectActividadesGrupoEspecieState, selectAll);
export const selectEntitiesActividadesGrupoEspecie = createSelector(
  selectActividadesGrupoEspecieState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectActividadesGrupoEspecieError = createSelector(
  selectActividadesGrupoEspecieState,
  getError
);

// MemoizedSelector<object,any>
export const selectActividadesGrupoEspecieIsLoading = createSelector(
  selectActividadesGrupoEspecieState,
  getIsLoading
);
